export default __webpack_public_path__ + "static/media/Icons_Sign_Out_Regular.75f6e15a.svg";